import React, { Component } from "react";
import { Text } from "react-internationalization";
import { connect } from "react-redux";
class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {isExpand:false};
    }

    render() {
        const {  selectedPlan} = this.props;
        const flag= selectedPlan == "SDAHMO20"?true:false;
        const flag1= selectedPlan == "RETIREE"?true:false;
        return (
            <div className="card">
                <h3 className="card-header block-heading"><Text id="inst.head" /><a className={this.state.isExpand?"fa fa-minus":"fa fa-plus"} data-toggle="collapse" data-target="#Instructions" style={{color:"#344c66",textDecoration:"none",cursor:"pointer"}} onClick={()=>this.setState({isExpand:!this.state.isExpand})}></a></h3>
                <div className={this.state.isExpand?"d-block":"panel-collapse collapse"} id="Instructions">
                    <div className="card-body">
                        <p><Text id={(flag || flag1)?"inst.inst1":"inst.i23Sharp"}/>.</p>
                        <p>
                         <Text id={(flag || flag1)?"inst.inst2":"inst.i25"}/>.</p>
                        <div className="row mt-4">
                            <div className="col-6">
                                <div className="box-item">
                                    <h4><Text id="inst.i1"/></h4>
                                    <p><Text id="inst.i2"/></p>
                                    <p><strong><Text id="inst.i3"/></strong></p>
                                    <ul>
                                        <li><Text id="inst.i4"/></li>
                                        <li><Text id="inst.i5"/></li>
                                    </ul>
                                    <p><strong><Text id="inst.i6"/></strong> <Text id="inst.i7"/></p>
                                    <ul>
                                        <li><Text id="inst.i8"/></li>
                                        <li><Text id="inst.i9"/></li>
                                    </ul>
                                </div>
                                <div className="box-item mt-4">
                                    <h4><Text id={(flag || flag1)?"inst.i18":"inst.i10"}/></h4>
                                    {(flag || flag1)?"":<p><Text id="inst.i11"/></p>}
                                    <ul>
                                        <li><Text id={(flag || flag1)?"inst.i19":"inst.i12"}/></li>
                                        <li><Text id= {(flag || flag1)?"inst.i20":"inst.i13"}/></li>
                                        {(flag || flag1)?"": <li><Text id="inst.i14"/></li>}
                                       
                                    </ul>
                                    {!flag && !flag1 && this.props.year==="2022"?<p><Text id="inst.i28a"/>&nbsp;<strong>Medicare.gov</strong>&nbsp;<Text id="inst.i28b"/>.</p>:null}
                                    {(flag || flag1)? <p><strong><Text id="inst.i22"/></strong> <Text id="inst.i21"/></p>:null}
                                </div>
                                {flag?
                                <div className="box-item">
                                <h4><Text id="inst.i15"/></h4>
                                <ul>
                                    <li><Text id="inst.i16"/></li>
                                    <li><Text id="inst.i17"/></li>
                                </ul>
                                </div>
                                :
                                (flag1?(
                                    <div className="box-item">
                                    <h4><Text id="inst.i15"/></h4>
                                    <ul>
                                        <li><Text id="inst.i17"/></li>
                                    </ul>
                                    </div> 
                                ):
                                    <div className="box-item mt-4">
                                        {this.props.year==="2022" ?(
                                        <h4><Text id="inst.i26"/></h4>
                                        ):
                                        <h4><Text id="inst.i10"/></h4>
                                        }
                                        <p><Text id="inst.i27Sharp"/>.
                                        <Text id="inst.i28"/>.</p>
                                        <p><strong>En español</strong>: Llame a Sharp Health Plan al 1-855-562-8853, TTY 711 o a Medicare gratis al 1-800-633-4227 y oprima el 2 para asistencia en español y un representante estará disponible para asistirle.</p>
                                    </div>
                                )
                                
                                }
                            </div>

                            <div className="col-6">                                
                                <div className="box-item">
                                    <h4><Text id={(flag || flag1)?"inst.inst3head":"inst.i15"}/></h4>
                                    <ul>
                                        <li><Text id={(flag || flag1)?"inst.inst3i":"inst.i16"}/></li>
                                        <li><Text id={(flag || flag1)?"inst.inst3ii":"inst.i17"}/></li>
                                    </ul>
                                </div>
                                <div className="box-item mt-4">
                                    <h4><Text id="inst.i29"/></h4>
                                    {/* {(flag || flag1)?
                                     <p><Text id="inst.inst4"/>: <br/> <Text id="inst.inst4i"/></p>: */}
                                    <>
                                        <span><Text id="inst.i30Sharp"/></span><br/>
                                        <div className="ml-2">
                                            <span><Text id="inst.i31Sharp1"/></span><br/>
                                            <span><Text id="inst.i31Sharp2"/></span><br/>
                                            <span><Text id="inst.i31Sharp3"/></span><br/>
                                        </div>
                                    </>
                                    {/* } */}
                                    <p><Text id={(flag || flag1)?"inst.inst4ii":"inst.i32"}/>.</p>
                                </div>
                                <div className="box-item mt-4">
                                    <h4><Text id={(flag || flag1)?"inst.inst5":"inst.i18"}/> </h4>
                                    {(flag || flag1)?
                                    <>
                                    <p><Text id="inst.inst5i"/>.</p>
                                    <p><Text id="inst.inst5ii"/>.</p>
                                    <p><Text id="inst.inst5iii"/>.</p>
                                    </>
                                    :<ul>
                                        <li><Text id="inst.i19"/>
                                        <br />
                                            <img
                                                src={require("../../../assests/images/Medicardlogoshp_New.png")}
                                                alt=""
                                                class="width100per"
                                            />
                                        </li>
                                        <li><Text id="inst.i20"/> </li>
                                    </ul>
                                    }
                                   {(flag || flag1)?"" :<p><strong><Text id="inst.i22"/></strong>: <Text id="inst.i21"/></p>}
                                
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
const mapStateToProps = (state) => {
    return {
      year: state.webApp.year,
      
    };
  };
export default connect(mapStateToProps)(Header); 